import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';

import { REACT_APP_DOMAIN } from '../../constants';

import { META_TAGS } from './MetaTags';
import { CampaignTriggerContext } from 'src/context/CampaignTriggerContext';
import Loader from '../Loader/Loader';

interface IReactHelmetWrapper {
  routeComponent: React.ComponentType<any>;
}

const ReactHelmetWrapper: React.FunctionComponent<IReactHelmetWrapper> = ({
  routeComponent: RouteComponent,
}) => {
  const { pathname } = useLocation();
  const campaignContext = useContext(CampaignTriggerContext);

  const { campaignTriggerLoading } = campaignContext;
  if (campaignTriggerLoading) {
    return <Loader lightBg={true} />;
  }

  return (
    <React.Fragment>
      <Helmet>
        <link
          rel="canonical"
          href={`${REACT_APP_DOMAIN}${pathname ? pathname : ''}`}
        />
        {Object.prototype.hasOwnProperty.call(META_TAGS, pathname) &&
          META_TAGS[pathname].length > 0 &&
          META_TAGS[pathname]}
      </Helmet>
      <RouteComponent />
    </React.Fragment>
  );
};

export default ReactHelmetWrapper;
